import { BUSINESS_SCALE_OPTIONS } from '@/lib/clientBusinessScaleEnums';
import {
  MARKETING_AREA_OPTIONS,
  MARKETING_SYSTEM_OPTIONS,
} from '@/lib/clientMarketingEnums';

/**
 * Merge `/me` tenant_profile into persisted settings businessData.
 * @param {Record<string, string>} prevBiz
 * @param {Record<string, unknown>} tp
 */
export function mergeClientProfileIntoBusinessData(prevBiz, tp) {
  if (!tp || typeof tp !== 'object') return prevBiz;
  const next = { ...prevBiz };

  if (typeof tp.name === 'string' && tp.name.trim()) next.companyName = tp.name.trim();
  if (typeof tp.address === 'string') next.address = String(tp.address).trim();

  if (typeof tp.product_type === 'string') next.productType = tp.product_type.trim();
  if (typeof tp.pic_name === 'string') next.picName = tp.pic_name.trim();
  if (typeof tp.pic_phone === 'string') next.picPhone = tp.pic_phone.trim();
  if (typeof tp.pic_email === 'string') next.picEmail = tp.pic_email.trim();

  if (Object.prototype.hasOwnProperty.call(tp, 'nib')) {
    const v = tp.nib;
    next.nib = typeof v === 'string' ? v.trim() : '';
  }
  if (Object.prototype.hasOwnProperty.call(tp, 'distribution_permit')) {
    const v = tp.distribution_permit;
    next.distributionPermit = typeof v === 'string' ? v.trim() : '';
  }
  if (Object.prototype.hasOwnProperty.call(tp, 'business_scale')) {
    const v = tp.business_scale;
    next.businessScale =
      typeof v === 'string' && BUSINESS_SCALE_OPTIONS.some((o) => o.value === v) ? v : '';
  }

  if (Object.prototype.hasOwnProperty.call(tp, 'marketing_area')) {
    const v = tp.marketing_area;
    next.marketingArea =
      typeof v === 'string' && MARKETING_AREA_OPTIONS.some((o) => o.value === v) ? v : '';
  }
  if (Object.prototype.hasOwnProperty.call(tp, 'marketing_system')) {
    const v = tp.marketing_system;
    next.marketingSystem =
      typeof v === 'string' && MARKETING_SYSTEM_OPTIONS.some((o) => o.value === v) ? v : '';
  }
  return next;
}
